import React from 'react';

import Grid from 'shared-components/components/Grid';
import GridItem from 'shared-components/components/GridItem';

import StaticMapWithDrawings from '@components/common/StaticMapWithDrawings';

import EditIcon from '../EditIcon';

import './style.scss';

export default function Map({
  text,
  filters,
  isMobile,
  startLocalitySearch,
  startLocalitySearchOnKeyPress,
}) {
  return (
    <div
      tabIndex={0}
      role="button"
      className="hpmapblock__newline is-clickable"
      onClick={startLocalitySearch}
      onKeyDown={startLocalitySearchOnKeyPress}      
      aria-label={text?.ariaLabel}
      aria-haspopup="dialog"
    >
      <Grid className="hpmapblock c-txt--w" align="center">
        <GridItem behavior="fixed">
          <StaticMapWithDrawings
            filters={filters}
            containerClassName="hpmapblock__map c-bg--bg"
          />              
        </GridItem>
        <GridItem className="hpmapblock__text tp--ell">
          <Grid direction="column" className="tp--ell">
            {text.prefix}
            {text.label}
          </Grid>
        </GridItem>
        <GridItem behavior="fixed" className="hpmapblock__editicon">
          <EditIcon isMobile={isMobile} />
        </GridItem>          
      </Grid>
    </div>
  );
};